/*
 * Rip-a-pack hero: drag across the top of the pack to tear it open,
 * flip through the cards and claim the reward (a Shopify discount code).
 * Config comes from the JSON block rendered by sections/hero.liquid.
 */
(() => {
  const root = document.querySelector('[data-rip]');
  if (!root) return;

  const cfg = JSON.parse(root.querySelector('[data-rip-config]').textContent);
  const s = cfg.strings;
  const $ = (sel) => root.querySelector(sel);
  const pack = $('[data-pack]');
  const packTop = $('[data-pack-top]');
  const tearFill = $('[data-tear-fill]');
  const ripCards = $('[data-rip-cards]');
  const ripBtn = $('[data-rip-btn]');
  const ripHint = $('[data-rip-hint]');
  const confettiEl = $('[data-confetti]');
  const commons = cfg.cards || [];
  const KEY = 'tk_free_shipping';
  const toast = (msg) => window.PackportTheme && window.PackportTheme.toast(msg);
  const esc = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const store = {
    get() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } },
    set() { try { localStorage.setItem(KEY, '1'); } catch (e) { /* storage blocked */ } }
  };

  let ripped = false;
  let cardIdx = 0;
  let claimed = store.get();

  function renderCards() {
    const total = commons.length + 1;
    const html = commons.map((c, i) => `
      <div class="tcard" style="--i:${total - i};z-index:${total - i}" data-idx="${i}">
        <div class="tcard-inner" style="--tc:${esc(c.tc)}">
          <div class="tcard-head"><span>${esc(c.name)}</span><span>HP ${esc(c.hp)} ${esc(c.type)}</span></div>
          <div class="tcard-art">${esc(c.art)}</div>
          <div class="tcard-text">${esc(c.text)}</div>
          <div class="tcard-foot"><span>${esc(cfg.brand)} · ${esc(s.common)}</span><span>${String(i + 1).padStart(3, '0')}/${String(total).padStart(3, '0')}</span></div>
        </div>
      </div>`).join('');
    const r = cfg.reward;
    const hit = `
      <div class="tcard hit ${claimed ? 'claimed' : ''}" style="--i:0;z-index:0" data-idx="${commons.length}">
        <div class="tcard-inner">
          <div class="hit-rarity">${esc(r.rarity)}</div>
          <div class="hit-icon">${esc(r.icon)}</div>
          <div class="hit-title">${esc(r.title)}<em>${esc(r.titleAccent)}</em></div>
          <div class="hit-sub">${esc(r.sub)}</div>
          ${cfg.code ? `<div class="hit-code" data-hit-code title="Kopieer">${esc(cfg.code)}</div>` : ''}
          <button type="button" class="btn btn-red btn-sm" data-claim>${claimed ? esc(s.claimed) : esc(s.claim)}</button>
        </div>
      </div>`;
    ripCards.innerHTML = html + hit;
  }

  const setTear = (p) => { tearFill.style.width = `${Math.min(p, 1) * 100}%`; };

  function updateUi() {
    const total = commons.length + 1;
    if (!ripped) {
      ripHint.textContent = s.hintStart;
      ripBtn.textContent = s.buttonStart;
      ripBtn.hidden = false;
    } else if (cardIdx < commons.length) {
      ripHint.textContent = s.hintNext.replace('[current]', cardIdx + 1).replace('[total]', total);
      ripBtn.textContent = s.buttonNext;
      ripBtn.hidden = false;
    } else {
      ripHint.textContent = claimed ? s.hintClaimed : s.hintHit;
      ripBtn.textContent = s.buttonAgain;
      ripBtn.hidden = !claimed;
    }
  }

  function rip() {
    if (ripped) return;
    ripped = true;
    setTear(1);
    pack.classList.remove('shake');
    packTop.classList.add('torn');
    setTimeout(() => {
      pack.classList.add('opened');
      ripCards.classList.add('show');
      if (!commons.length) popHit();
      updateUi();
    }, 450);
  }

  function popHit() {
    ripCards.querySelector('.hit').classList.add('hit-pop');
    confetti();
  }

  function nextCard() {
    if (!ripped || cardIdx >= commons.length) return;
    ripCards.querySelector(`[data-idx="${cardIdx}"]`).classList.add('gone');
    cardIdx += 1;
    if (cardIdx === commons.length) popHit();
    updateUi();
  }

  function reset() {
    ripped = false;
    cardIdx = 0;
    ripCards.classList.remove('show');
    pack.classList.remove('opened');
    packTop.classList.remove('torn');
    setTear(0);
    renderCards();
    updateUi();
  }

  function confetti() {
    const colors = ['#bc102f', '#ffd24a', '#ffffff', '#3ddcff', '#ff5a77', '#3ddc84'];
    confettiEl.innerHTML = Array.from({ length: 60 }, () => {
      const a = Math.random() * Math.PI * 2;
      const d = 120 + Math.random() * 180;
      return `<i style="background:${colors[(Math.random() * colors.length) | 0]};--x:${Math.cos(a) * d}px;--y:${Math.sin(a) * d - 60}px;--r:${Math.random() * 720 - 360}deg;animation-delay:${Math.random() * 0.15}s"></i>`;
    }).join('');
  }

  function showClaimedState() {
    const pill = document.querySelector('[data-ship-pill]');
    if (pill) pill.hidden = false;
    const msg = document.querySelector('.topbar-msg');
    if (msg && cfg.code) {
      msg.removeAttribute('data-rotator');
      msg.innerHTML = `<p class="is-active">${esc(s.topbar).replace('[code]', `<u>${esc(cfg.code)}</u>`)}</p>`;
    }
  }

  async function claim() {
    if (claimed) return;
    claimed = true;
    store.set();
    if (cfg.applyDiscount && cfg.code) {
      /* Visiting /discount/CODE stores the code in the shopper's session. */
      try { await fetch(`/discount/${encodeURIComponent(cfg.code)}`, { credentials: 'same-origin' }); } catch (e) { /* offline preview */ }
    }
    showClaimedState();
    const hit = ripCards.querySelector('.hit');
    hit.classList.add('claimed');
    hit.querySelector('[data-claim]').textContent = s.claimed;
    toast(s.activated);
    updateUi();
  }

  /* Drag across the top strip to tear it open */
  let dragStart = null;
  packTop.addEventListener('pointerdown', (e) => {
    if (ripped) return;
    dragStart = e.clientX;
    packTop.setPointerCapture(e.pointerId);
    pack.classList.add('shake');
  });
  packTop.addEventListener('pointermove', (e) => {
    if (dragStart === null) return;
    const p = Math.abs(e.clientX - dragStart) / (packTop.clientWidth * 0.55);
    setTear(p);
    if (p >= 1) { dragStart = null; rip(); }
  });
  const endDrag = () => {
    if (dragStart === null) return;
    dragStart = null;
    pack.classList.remove('shake');
    if (!ripped) setTear(0);
  };
  packTop.addEventListener('pointerup', endDrag);
  packTop.addEventListener('pointercancel', endDrag);

  ripBtn.addEventListener('click', () => {
    if (!ripped) {
      pack.classList.add('shake');
      let p = 0;
      const step = () => { p += 0.06; setTear(p); if (p < 1) requestAnimationFrame(step); else rip(); };
      requestAnimationFrame(step);
    } else if (cardIdx < commons.length) {
      nextCard();
    } else {
      reset();
    }
  });

  ripCards.addEventListener('click', (e) => {
    if (e.target.closest('[data-claim]')) { claim(); return; }
    if (e.target.closest('[data-hit-code]')) {
      if (navigator.clipboard) navigator.clipboard.writeText(cfg.code).then(() => toast(s.copied.replace('[code]', cfg.code)), () => {});
      return;
    }
    if (e.target.closest('.tcard:not(.hit)')) nextCard();
  });

  renderCards();
  updateUi();
  if (claimed) showClaimedState();
})();
